import React from 'react';

const Divider = ({id="",height="1px",color="#ebebeb"}) => {
    return (
        <div id={id} style={{margin:"15px 0px",width:"100%",background:color, height:height, borderBottom:"1px solid "+color}}></div>
    )
};

export default Divider;